__turbopack_context__.v({
  "address": "WalletReceive-module__oaa6sa__address",
  "cancelButton": "WalletReceive-module__oaa6sa__cancelButton",
  "copyButton": "WalletReceive-module__oaa6sa__copyButton",
  "copyButtonContainer": "WalletReceive-module__oaa6sa__copyButtonContainer",
  "description": "WalletReceive-module__oaa6sa__description",
  "header": "WalletReceive-module__oaa6sa__header",
  "qrCode": "WalletReceive-module__oaa6sa__qrCode",
  "qrContainer": "WalletReceive-module__oaa6sa__qrContainer",
  "qrFooter": "WalletReceive-module__oaa6sa__qrFooter",
  "receive": "WalletReceive-module__oaa6sa__receive",
  "root": "WalletReceive-module__oaa6sa__root",
  "sendRcvIconContainer": "WalletReceive-module__oaa6sa__sendRcvIconContainer",
  "swapOption": "WalletReceive-module__oaa6sa__swapOption",
});
